// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__320pW","footerDiv":"Footer_footerDiv__1M6sx","left":"Footer_left__3Anr9","right":"Footer_right__1UACq"};